import { AxiosResponse } from "axios"
import $api from "../../../axios"
import { ICustomer } from "../types/customers"

const api = `/customerEdit/`

export const getCustomers = async () => {
  const result = await $api.get<ICustomer[], AxiosResponse<ICustomer[]>>(`${api}getCustomers`)
  return result.data
}

export const editAccessesPagesToCustomer = async (
  customerId: string,
  newListAccesesPage: [string]
) => {
  const result = await $api.post<AxiosResponse>(`${api}editAccesesPageToCustomers`, {
    customerId,
    newListAccesesPage,
  })
  return result.data
}

interface IUserData {
  fullName: string
  email: string
  phoneNumber: string
  password: string
  accessesPages: [string]
  roles: [string]
}

export const createNewCustomer = async (userData: IUserData) => {
  const result = await $api.post<AxiosResponse>(`${api}createNewCustomer`, {
    ...userData,
  })
  return result.data
}

interface IUserDataWithId extends IUserData {
  _id: string
}

export const editCustomer = async (userData: IUserDataWithId) => {
  const result = await $api.post<AxiosResponse>(`${api}editCustomers`, {
    ...userData,
  })
  return result.data
}

export const generateRandomPassword = async (): Promise<string> => {
  const result = await $api.get<string>(`${api}generateRandomPassword`)
  return result.data
}
